import React from "react";

const SlotM = (props)=>{
    // let x = '😃';
    // let y = '😃';
    // let z = '😆';

    // let x = props.x;
    // let y = props.y;
    // let z = props.z;


    let {x,y,z} = props;


if (x === y && y === z ){
    return (
        <>
            <h1>{x} {y} {z}</h1>
            <h2>This is mactching</h2>
        </>
    )
} else {
    return (
        <>
            <h1>{x} {y} {z}</h1>
            <h2>This is not mactching</h2>
        </>
    )
}
}
export default SlotM;